/**
 * Taxa média da aba "Coberturas e Serviços" das análises PME.
 *
 * A taxa é DERIVADA dos dois números que já estão na própria linha — prêmio e
 * capital segurado — e não de um campo da tarifação:
 *
 *     taxa (‰) = prêmio ÷ capital × 1000
 *
 * Antes cada tela lia um campo diferente do tarifado (a cotação usava
 * `pureRate`, a proposta `commercialRate` com fallback para `netRate`), e a
 * mesma cobertura aparecia com números distintos ao passar de uma para a
 * outra. Calculando a partir da linha, o valor exibido fecha com o que o
 * usuário vê ao lado e as duas telas voltam a concordar.
 */

const DASH = '—';

/**
 * Prêmio ÷ capital × 1000. Devolve `null` quando falta um dos dois ou quando o
 * capital é zero — sem capital não há taxa, e dividir por zero daria `Infinity`
 * na tela.
 */
export function averageRatePerMille(
  premium: number | null | undefined,
  capital: number | null | undefined
): number | null {
  if (premium == null || capital == null) return null;
  if (!Number.isFinite(premium) || !Number.isFinite(capital)) return null;
  if (capital === 0) return null;

  return (premium / capital) * 1000;
}

/** Formato da coluna "Taxa Média (‰)". */
export function formatAverageRatePerMille(value: number | null): string {
  if (value == null) return DASH;

  return value.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 5,
  });
}

/** Atalho para as telas: calcula e formata numa chamada só. */
export function resolveAverageRatePerMille(
  premium: number | null | undefined,
  capital: number | null | undefined
): string {
  return formatAverageRatePerMille(averageRatePerMille(premium, capital));
}
